<template>
	<base-button :class="{'reduced-padding-btn': $uiHelpers.isMobileOrTablet}" outline @mouseover.native="hover = true" @mouseleave.native="hover = false" v-bind="$attrs" @click="action ? action() : null">
	<span v-if="reverse" class="mr-2">{{ text }}</span><base-icon class="btn-icon" :color="$attrs.textColor" :src="icon" /><span v-if="!reverse && text" class="ml-2">{{ text }}</span></base-button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String
    },
    text: {
      type: String
    },
		reverse: {
			type: Boolean,
			default: false
		},
		action: {
			type: Function
		}
  },
  data () {
    return {
      hover: false
    }
  },
	computed: {
		activeBlueColor () {
			return !this.hover && this.$attrs.blue
		},
		activeWhiteColor () {
			return !this.activeBlueColor && this.$attrs.white
		}
	}
}
</script>

<style scoped lang="scss">
  .btn-icon {
    vertical-align: text-bottom;
    display: inline-flex;
    width: 12px;
  }
  .reduced-padding-btn{
    padding: 0.5rem 1rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/base/buttons/IconButton.vue